module.exports = __webpack_public_path__ + "img/simulator_logo_green.0218b3cb.svg";